import axios from 'axios'
// import _ from 'lodash'
import env from '@/env.js'

export default axios.create({
  baseURL: env.ranchApiUrl
})

// const handler = {
//   requestSuccessHandler (config) {
//     return config
//   },
//   requestFailureHandler (error) {
//     return Promise.reject(error)
//   },
//   responseSuccessHandler (res) {
//     if (env.debug) {
//       console.log(_.get(res, 'config.url'))
//       console.log(res.data.data)
//     }
//     return res
//   },
//   responseFailureHandler (error) {
//     // let req = error.request
//     // let res = error.response
//     if (env.debug) {
//       console.error(_.get(error, 'config.url'))
//       console.error(error)
//     }
//     return Promise.reject(error)
//   }
// }



// WEBPACK FOOTER //
// ./src/api/ranch.js